import React, { useEffect, useState, useRef, useContext } from 'react'
import { initTree } from './Tree'
import PersonIcon from '@mui/icons-material/Person'
import GlobalSpinner from '../Common/GlobalSpinner'
import { UserContext } from '../../context/UserContext'
import LoginAutodesk from '../LoginAutodesk/LoginAutodesk'
import DoDisturbIcon from '@mui/icons-material/DoDisturb'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import ButtonDocuActivateHub from '../Buttons/ButtonDocuActivateHub'
import { ViewerContext } from '../../context/ViewerContext'
import TreeSkeleton from '../Spinner/Skeletons/TreeSkeleton'

function TooltipNotShowTree() {
  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Tienes que tener una suscripción activa para ver los modelos
    </Tooltip>
  )

  return (
    <OverlayTrigger
      placement="right"
      delay={{ show: 250, hide: 400 }}
      overlay={renderTooltip}
    >
      <DoDisturbIcon style={{ fill: 'red' }} />
    </OverlayTrigger>
  )
}

const AccTree = ({
  onIdSelected,
  versionName,
  visibleTree,
  versionArray,
  isCorrectUser,
}) => {
  const treeContainerRef = useRef(null)
  const { isLoading, user } = useContext(UserContext)
  const [refVisible, setRefVisible] = useState(false)
  const [isTreeLoading, setIsTreeLoading] = useState(true)
  const { setSelectedGuidViewCurrentModel, handleRelaunchViewer } =
    useContext(ViewerContext)

  useEffect(() => {
    if (refVisible && user) {
      const selector = treeContainerRef.current
      setIsTreeLoading(true)
      initTree(
        selector,
        (id) => onIdSelected(id),
        (name) => versionName(name),
        (versions) => versionArray(versions),
        setSelectedGuidViewCurrentModel,
        handleRelaunchViewer,
        () => setIsTreeLoading(false)
      )
    }
  }, [refVisible, user])

  if (isLoading) return <GlobalSpinner />
  if (!user?.autodeskEmail) return <LoginAutodesk />

  return (
    <div
      style={{
        minWidth: 'fit-content',
        width: '100%',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '2rem 1rem',
          gap: '1rem',
          justifyContent: 'space-between',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'flex-end', gap: '.5rem' }}>
          <PersonIcon fontSize="large" style={{ color: '#3A6079' }} />
          <span style={{ fontStyle: 'italic' }}>{user?.nombreAutodesk}</span>
        </div>
        <ButtonDocuActivateHub />
      </div>
      {!visibleTree && <TooltipNotShowTree />}
      {visibleTree && isCorrectUser && (
        <>
          {isTreeLoading && <TreeSkeleton />}
          {/* mientras carga sacamos el arbol del flujo (no del DOM: initTree
              necesita la ref) para que el margin !important de .inspire-tree
              no reserve espacio debajo del skeleton */}
          <div
            className="inspire-tree"
            style={
              isTreeLoading
                ? {
                    position: 'absolute',
                    left: '-9999px',
                    visibility: 'hidden',
                  }
                : undefined
            }
            ref={(el) => {
              treeContainerRef.current = el
              setRefVisible(!!el)
            }}
          />
        </>
      )}
    </div>
  )
}

export default AccTree
